<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Customizations/External_Components';
    let nextLink= '/Documentation/Customizations/Typer_Customization';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="customization-of-the-scoper-1"
  bind:intersecting={visibleById["customization-of-the-scoper-1"]}
  onIntersectChange={(visible) => setVisible("customization-of-the-scoper-1", visible)}
>Customization of the Scoper</SectionComponent>
<p>The scoper cannot yet be customized <strong>per concept</strong>.<br>
Instead, you can replace the entire scoper with your own implementation.<br>
Your custom scoper must implement the standard <code>FreScoper</code> interface.</p>
<SectionComponent tag="h2" 
  id="adjusting-the-environment-2"
  bind:intersecting={visibleById["adjusting-the-environment-2"]}
  onIntersectChange={(visible) => setVisible("adjusting-the-environment-2", visible)}
>Adjusting the Environment</SectionComponent>
<p>To make Freon use your custom scoper instead of the generated one, modify the initialization line in the class<br>
<code>YourLanguageNameEnvironment</code> (found in <code>~/freon/environment/</code>).<br>
Replace <code>YourLanguageName</code> with the name of your DSL.</p>
<p>Suppose your improved scoper is implemented in the class <code>YourScoper</code>.<br>
Then the relevant line in the environment class should look like this:</p>
<pre class="language-ts"><code class="language-ts">export class EntityEnvironment implements FreEnvironment &#123;
    ...
    scoper: FreScoper = new YourScoper();
    ...
&#125;</code></pre>


<PrevNextSection {prevLink} {nextLink} />